import {Directive, Input} from '@angular/core';
import {AbstractControl, NG_VALIDATORS, Validator} from '@angular/forms';

@Directive({
  selector: '[appPercentageCustomValidator]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: PercentageCustomValidatorDirective,
    multi: true
  }]
})
export class PercentageCustomValidatorDirective implements Validator {

  @Input('appPercentageCustomValidator') total: string;

  validate(control: AbstractControl): { [key: string]: any } | null {
    const val = +control.value;
    const total = val + +this.total;
    return total > 100 ? {'totalpercentage': true} : null;
  }

  registerOnValidatorChange?(fn: () => void): void {

  }
}
